import { useTranslation } from 'react-i18next';

export const RestrictionBanner = () => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex w-full items-center justify-center gap-3 bg-black px-6 py-3 text-center"
    >
      <p className="text-[15px] font-medium leading-5 tracking-[-0.15px] text-white">
        {t('community.restriction_banner.banned')}
      </p>
    </div>
  );
};
